import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { DriverService } from "./driver.service";

@Injectable()
export class DriversResolver {
  constructor(private driverService: DriverService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("Driver Resolver");
    return this.driverService.getDriverList(true, false);
  }
}
